import { type GetMetricsQueryParams } from '@gonfalon/openapi/operations/getMetrics';

import { createInfiniteQueryHook } from '../internal/createInfiniteQueryHook';
import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

/**
 * @deprecated Use `useInfiniteQuery` directly with appropriate query options.
 */
export const useInfiniteMetrics = createInfiniteQueryHook(
  ({ projectKey, params }: { projectKey: string; params?: GetMetricsQueryParams }) => ({
    queryKey: ['infinite-metrics', projectKey, params],
    queryFn: async ({ pageParam }) => {
      const { getMetrics } = await import('@gonfalon/openapi/operations/getMetrics');
      return reactQueryResponseAdapter(
        getMetrics({
          projectKey,
          query: { ...params, ...pageParam },
        }),
      );
    },
    initialPageParam: {
      offset: params?.offset ?? 0,
      limit: params?.limit ?? 15,
    } as GetMetricsQueryParams,
    getNextPageParam: (lastPage, allPages) => {
      const limit = params?.limit ?? 15;
      const totalCount = lastPage.totalCount ?? 0;
      const currentOffset = allPages.length * limit;

      if (currentOffset >= totalCount) {
        return undefined;
      }

      return {
        offset: currentOffset,
        limit,
      } as GetMetricsQueryParams;
    },
  }),
);
